import _ from 'lodash';

export default angular.module('cian.newbuild.serp.serpListHeader', ['cian.ui.selectpopup'])
.controller('SerpListHeader', [
  '$log',
  '$scope',
  '$window',
  'SerpListService',
  'FilterService',
  'FilterSortService',
  'ApiService',
  'StateService',
  'AnalyticsService',
  'SerpViewMode',
  'ShowOffersService',
  ($log, $scope, $window, SerpListService, FilterService, FilterSortService, ApiService, StateService, AnalyticsService, SerpViewMode, ShowOffersService) => {
  const ctrl = {};

  $scope.$watch(
    () => FilterService.filter,
    newValue => {
      ctrl.filter = newValue;
    }
  );

  ctrl.title = SerpListService.getSearchTitle();

  ctrl.getOffersCount = SerpListService.getOffersCount;
  ctrl.getSimilarOffersCount = SerpListService.getSimilarOffersCount;
  ctrl.getBsCenterListUrl = SerpListService.getBsCenterListUrl;
  ctrl.isInitialPageLoad = () => !SerpListService.lastGetOffersResult;

  ctrl.isLandingHeaderVisible = () =>
    // Шапка ЖК
    ($window._landingHeader.newobject && SerpListService.isInitialNewObjectSelected()) ||
    // Шапка БЦ
    ($window._landingHeader.BC && SerpListService.isInitialBCSelected()) ||
    // Шапка застройщика
    ($window._landingHeader.builder && SerpListService.isInitialBuilderSelected());


  // Сортировка

  FilterSortService.init(
    _.get(FilterService, 'filter.sort.value'),
    _.get(FilterService, 'filter.quality.value'),
  );

  ctrl.sort = {
    type: FilterSortService.sort,
    quality: FilterSortService.quality,
    items: [],
  };

  $scope.$watch(
    () => FilterSortService.sortItems,
    newValue => {
      ctrl.sort.items = newValue;
    }
  );

  ctrl.onSortChange = () => {
    // Если выбрано "по умолчанию", то проставляем галочку "учитывать качество"
    if (!ctrl.sort.type.value) ctrl.sort.quality.value = true;

    SerpListService.sortOffers();

    const trackingMapSortName = (name) => {
      let map = {
        price_object_order: 'price',
        price_square_order: 'price_per_metr',
        walking_time: 'time_to_metro_area',
        id_user: 'ID',
      };

      return map[name] || name || 'default';
    }

    window.ca && ca('event', {
      name: 'oldevent',
      category: 'Listing',
      action: 'sorting',
      label: trackingMapSortName(ctrl.sort.type.value),
    });
  };


  // Карточка застройщика в шапке ЖК
  ctrl.isBuilderCardVisible = false;
  let builderGALabels;
  ctrl.initBuilderCard = gaLabels => {
    builderGALabels = gaLabels;
    updateBuilderCardVisibility();
  };

  function updateBuilderCardVisibility() {
    ctrl.isBuilderCardVisible = _.get(SerpListService.lastQuery, 'from_developer.value');

    if (ctrl.isBuilderCardVisible) {
      AnalyticsService.trackCA('Listing', 'show_jk_head_block_phone', builderGALabels);
    }
  }


  // Закрытая база
  ctrl.isHiddenBaseAvailable = () => !FilterService.isNewBuilding();
  ctrl.onHiddenBaseChange = () => ShowOffersService.updateOffers();


  // Табы вида выдачи
  ctrl.setViewMode = SerpViewMode.setMode;
  ctrl.isViewAvailable = SerpViewMode.isModeAvailable;
  ctrl.viewModeIs = SerpViewMode.currentModeIs;

  ctrl.getMapUrl = () => {
    const firstOffer = _.values(SerpListService.lastGetOffersResult.offersSerialized)[0];
    const coords = firstOffer.center.map(coord => coord.toFixed(6)).join(',');
    return `${SerpListService.getFullUrl('map')}&center=${coords}&zoom=15`;
  };

  const update = res => {
    if (!res) return;

    document.title = res.title;
    ctrl.title = res.h1;
    if (res.breadcrumbs) {
      ctrl.breadcrumbs = res.breadcrumbs;
    }

    updateBuilderCardVisibility();
  };

  $scope.$watch(() => SerpListService.lastGetOffersResult, update);

  return ctrl;
}])
.name;



// WEBPACK FOOTER //
// ./src/serp/controllers/serp-list-header.js